import { Record } from 'immutable';

const CustomerIdentifierDefaults = {
  id: null,
  type: null,
  string: null,
  verified: false
};

class CustomerIdentifier extends Record(CustomerIdentifierDefaults) {}

export default CustomerIdentifier;



// WEBPACK FOOTER //
// banquet/models/CustomerIdentifier.js